export default function useDiamondShapeImageMap() {
    const shapeImageMap: {
        [key: string]: {
            img: string;
            label: string;
        };
    } = {
        AS: {
            img: require("@/assets/diamond-shapes/asscher.svg"),
            label: "Asscher"
        },
        BAG: {
            img: require("@/assets/diamond-shapes/baguette.svg"),
            label: "Baguette"
        },
        CB: {
            img: require("@/assets/diamond-shapes/cushion.svg"),
            label: "Cushion Brilliant"
        },
        CU: {
            img: require("@/assets/diamond-shapes/cushion.svg"),
            label: "Cushion"
        },
        EM: {
            img: require("@/assets/diamond-shapes/emerald.svg"),
            label: "Emerald"
        },
        HS: {
            img: require("@/assets/diamond-shapes/heart.svg"),
            label: "Heart"
        },
        MQ: {
            img: require("@/assets/diamond-shapes/marquise.svg"),
            label: "Marquise"
        },
        OV: {
            img: require("@/assets/diamond-shapes/oval.svg"),
            label: "Oval"
        },
        PR: {
            img: require("@/assets/diamond-shapes/princess.svg"),
            label: "Princess"
        },
        PS: {
            img: require("@/assets/diamond-shapes/pear.svg"),
            label: "Pear"
        },
        RA: {
            img: require("@/assets/diamond-shapes/radiant.svg"),
            label: "Radiant"
        },
        RD: {
            img: require("@/assets/diamond-shapes/round-brilliant.svg"),
            label: "Brilliant"
        },
        TRIL: {
            img: require("@/assets/diamond-shapes/trilliant.svg"),
            label: "Trilliant"
        }
    };

    return shapeImageMap;
}
